import { ReactNode } from "react";
import { useModalStateManager } from "../../hooks";
import { View } from "./View";

export interface IQuickSubmitFormProps {
  isModalOpen: boolean;
  closeModal: () => void;

  isDeleteLocked: boolean; // item cannot be deleted
  deleteLockedInfo?: ReactNode;

  buttonKind?:
    | "tertiary"
    | "success"
    | "secondary"
    | "danger"
    | "warning"
    | "primary";

  isSubmitting: boolean;
  isSuccess: boolean;

  formTitle?: ReactNode;
  formSubtitle?: ReactNode;
  buttonText?: ReactNode;
  confirmationMessage?: ReactNode;
  onButtonClick: (doNotPassParams?: any) => void;
}

export interface IQuickSubmitFormViewProps extends IQuickSubmitFormProps {}

export const QuickSubmitForm = (props: IQuickSubmitFormProps) => {
  return <View {...props} />;
};
